import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 25, height: 24, fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M22.754 12a2.6 2.6 0 0 1-1.209 2.199L9.943 21.588a2.62 2.62 0 0 1-4.03-2.2V4.612a2.62 2.62 0 0 1 4.03-2.2l11.602 7.39A2.6 2.6 0 0 1 22.755 12m-3.634 0L9.07 5.602v12.796z" }));
const ForwardRef = forwardRef(SvgPlay);
export { ForwardRef as ReactComponent };
